import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { AuthProvider } from "./lib/auth";
// Side-effect import: initialises i18next before any component
// renders so the first useTranslation() call already has resources.
import "./lib/i18n";
import "./styles.css";

const vRoot = document.getElementById("root");	// SPA mount point

if (vRoot === null)
{
	throw new Error("#root not found");
}

ReactDOM.createRoot(vRoot).render(
	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<App />
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>
);
